export class RegulationQuery {
  constructor(answer, query, status, statusText) {
    this.answer = answer;
    this.query = query;
    /**@type {status} */
    this.status = status;
    /**@type {Classification} */
    this.statusText = statusText;
  }
  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new RegulationQuery(
        input.answer,
        input.query,
        input.status,
        input.status_text,
      )
    }
    return new RegulationQuery();
  }
  static fromApiArray(input) {
    if (Array.isArray(input)) {
      return input.map(item => RegulationQuery.fromApiObject(item));
    }
    if (input && typeof (input) === "object") {
      return [RegulationQuery.fromApiObject(input)];
    }
    return [];
  }
}